module.exports = __webpack_public_path__ + "img/menu-banner-orange-assist.27a3f419.png";